export const InfoIcon = () => {
  return (
    <>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1892_58114)">
          <path
            d="M14.9321 11.9287C15.0981 11.9286 15.2627 11.9619 15.416 12.0254C15.5694 12.0889 15.7089 12.1814 15.8262 12.2988C15.9435 12.4162 16.0362 12.5556 16.0996 12.709C16.163 12.8624 16.1956 13.0274 16.1953 13.1934L16.1953 21.1172C16.1953 21.4519 16.0624 21.7731 15.8257 22.0098C15.589 22.2464 15.2683 22.3789 14.9336 22.3789C14.5989 22.3789 14.2777 22.2464 14.041 22.0098C13.8043 21.7731 13.6714 21.4519 13.6714 21.1172L13.6714 13.1934C13.6711 13.0275 13.7034 12.8632 13.7666 12.71C13.8298 12.5567 13.9229 12.4172 14.04 12.2998C14.1571 12.1824 14.2961 12.089 14.4492 12.0254C14.6023 11.9618 14.7663 11.9288 14.9321 11.9287Z"
            fill="#FB5050"
          />
          <path
            d="M14.9335 11.1484C15.2049 11.148 15.4702 11.068 15.6957 10.917C15.9212 10.766 16.0969 10.5516 16.2006 10.3008C16.3042 10.05 16.3312 9.77396 16.2782 9.50781C16.2252 9.24166 16.0941 8.99658 15.9022 8.80469C15.7103 8.61279 15.4657 8.48273 15.1996 8.42969C14.9334 8.37665 14.6579 8.40316 14.4071 8.50684C14.1563 8.61051 13.9419 8.78624 13.7909 9.01172C13.6399 9.2372 13.5589 9.50205 13.5585 9.77344C13.5585 10.1381 13.7034 10.4882 13.9613 10.7461C14.2192 11.004 14.5688 11.1484 14.9335 11.1484Z"
            fill="#FB5050"
          />
          <path
            d="M15 1.5C7.54416 1.5 1.5 7.54415 1.5 15C1.5 22.4558 7.54416 28.5 15 28.5C22.4558 28.5 28.5 22.4558 28.5 15C28.5 7.54416 22.4558 1.5 15 1.5Z"
            stroke="#FB5050"
            stroke-width="3"
          />
        </g>
        <defs>
          <clipPath id="clip0_1892_58114">
            <rect
              width="30"
              height="30"
              fill="white"
              transform="translate(30 30) rotate(-180)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const IconClose = () => {
  return (
    <>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.05308 6.35208C7.94146 6.24046 7.80894 6.15191 7.6631 6.0915C7.51725 6.03109 7.36094 6 7.20308 6C6.88427 6 6.57852 6.12665 6.35308 6.35208C6.24146 6.46371 6.15291 6.59622 6.0925 6.74206C6.03209 6.88791 6.001 7.04422 6.001 7.20208C6.001 7.52089 6.12765 7.82665 6.35308 8.05208L13.3001 14.9981L6.35208 21.9451C6.12665 22.1705 6 22.4763 6 22.7951C6 23.1139 6.12665 23.4196 6.35208 23.6451C6.57752 23.8705 6.88327 23.9972 7.20208 23.9972C7.52089 23.9972 7.82665 23.8705 8.05208 23.6451L14.9991 16.6991L21.9451 23.6451C22.0567 23.7567 22.1892 23.8453 22.3351 23.9057C22.4809 23.9661 22.6372 23.9972 22.7951 23.9972C22.9529 23.9972 23.1093 23.9661 23.2551 23.9057C23.4009 23.8453 23.5335 23.7567 23.6451 23.6451C23.7567 23.5335 23.8452 23.4009 23.9057 23.2551C23.9661 23.1093 23.9972 22.9529 23.9972 22.7951C23.9972 22.6372 23.9661 22.4809 23.9057 22.3351C23.8452 22.1892 23.7567 22.0567 23.6451 21.9451L16.6981 14.9991L23.6471 8.05308C23.7587 7.94146 23.8472 7.80894 23.9077 7.6631C23.9681 7.51726 23.9992 7.36094 23.9992 7.20308C23.9992 7.04522 23.9681 6.88891 23.9077 6.74306C23.8472 6.59722 23.7587 6.46471 23.6471 6.35308C23.5355 6.24146 23.4029 6.15291 23.2571 6.0925C23.1113 6.03209 22.9549 6.001 22.7971 6.001C22.6392 6.001 22.4829 6.03209 22.3371 6.0925C22.1912 6.15291 22.0587 6.24146 21.9471 6.35308L15.0011 13.3001L8.05308 6.35108V6.35208Z"
          fill="white"
        />
      </svg>
    </>
  );
};
